import { useTheme as useTheme$1 } from '@emotion/react';

const THEME_ID = '$$se-giger';
const shadowSelector = ':where(:host)';
const useTheme = () => {
  const theme = useTheme$1();
  return THEME_ID in theme ? theme[THEME_ID] : theme;
};
const scope = themable => theme => {
  return themable === null || themable === void 0 ? void 0 : themable(THEME_ID in theme ? theme[THEME_ID] : theme);
};

export { THEME_ID, scope, shadowSelector, useTheme };
//# sourceMappingURL=useTheme.js.map
